import Components from "./components";
import Indices from "./indices";
import SecurityInformation from "./info";
import TimeSeries from "./time-series";

const ModuleName = "tfApp.security";

const dependencies = [
    Components(ModuleName),
    Indices(ModuleName),
    SecurityInformation(ModuleName),
    TimeSeries(ModuleName)
];

export default angular.module(ModuleName, dependencies)
                      .name;
